export const LOCAL_DB_NAME = 'walld-tattoo-demo';
export const LOCAL_DB_VERSION = 4;
export const LEGACY_RESULTS_STORE = 'results';
export const SCOPED_RESULTS_STORE = 'scoped-results';
export const RESULTS_OWNER_INDEX = 'ownerKey';
export const LOCAL_PHOTOS_STORE = 'local-photos';

export function openLocalDatabase(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(LOCAL_DB_NAME, LOCAL_DB_VERSION);
    request.onupgradeneeded = () => {
      // Existing result data is intentionally preserved during the additive
      // browser-storage upgrade. Raw body photos use their own device-only store.
      if (!request.result.objectStoreNames.contains(LEGACY_RESULTS_STORE)) {
        request.result.createObjectStore(LEGACY_RESULTS_STORE, { keyPath: 'sessionId' });
      }
      if (!request.result.objectStoreNames.contains(SCOPED_RESULTS_STORE)) {
        const store = request.result.createObjectStore(SCOPED_RESULTS_STORE, { keyPath: 'cacheKey' });
        store.createIndex(RESULTS_OWNER_INDEX, 'ownerKey', { unique: false });
      }
      if (!request.result.objectStoreNames.contains(LOCAL_PHOTOS_STORE)) {
        request.result.createObjectStore(LOCAL_PHOTOS_STORE, { keyPath: 'id' });
      }
    };
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error || new Error('Local storage is unavailable.'));
  });
}
